import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiResult } from 'services/InvoiceService'
import { historyRecordsApi } from 'services/RateCardService'

export const getData = createAsyncThunk(
    'verifiedInvoices/data/getData',
    async (data) => {
        const response = await historyRecordsApi(data)
        return response.data
    },
)

export const getResult = createAsyncThunk(
    'verifiedInvoices/data/getResult',
    async (data) => {
        const response = await getApiResult(data)
        return response.data
    },
)

export const getHistoryData = createAsyncThunk(
    'verifiedInvoices/data/getHistoryData',
    async (data) => {
        const response = await historyRecordsApi(data)
        return response.data
    },
)

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    selectedTab: 'Verified',
    sort: [{ column: '', dir: '' }],
    startDate: null,
    endDate: null,
}

const initialHistoryTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'verifiedInvoices/data',
    initialState: {
        loading: false,
        data: [],
        historyData: [],
        tableData: initialTableData,
        historyTableData: initialHistoryTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
        setHistoryTableData: (state, { payload }) => {
            state.historyTableData = payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, (state) => {
                state.loading = false
                state.data = []
            })

            //Result
            .addCase(getResult.pending, (state) => {
                state.loading = true
                state.result = null
            })
            .addCase(getResult.fulfilled, (state, { payload }) => {
                state.loading = false
                state.result = payload
            })
            .addCase(getResult.rejected, (state) => {
                state.loading = false
                state.result = null
            })

            //History Data
            .addCase(getHistoryData.pending, (state) => {
                state.loading = true
                state.historyData = []
            })
            .addCase(getHistoryData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.historyData = payload?.results
            })
            .addCase(getHistoryData.rejected, (state) => {
                state.loading = false
                state.historyData = []
            })
    },
})

export const { setData, setTableData, setHistoryTableData } = dataSlice.actions

export default dataSlice.reducer
